import React, { useState } from "react";
import { Box, Typography, Button, styled } from "@mui/material";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const DropzoneContainer = styled(Box)(({ theme }) => ({
  border: `2px dashed ${theme.palette.primary.main}`,
  borderRadius: "8px",
  padding: theme.spacing(3),
  textAlign: "center",
  cursor: "pointer",
  backgroundColor: theme.palette.background.paper,
}));

const ImagePreview = styled("img")({
  maxWidth: "100%",
  maxHeight: "200px",
  marginTop: "16px",
  borderRadius: "8px",
});

const SubeImagen = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [uploadedImage, setUploadedImage] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const onDrop = (acceptedFiles) => {
    const selectedFile = acceptedFiles[0];
    if (selectedFile) {
      setFile(selectedFile);
      const reader = new FileReader();
      reader.onload = () => {
        setUploadedImage(reader.result); // Previsualización
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { "image/*": [] },
    maxFiles: 1,
  });

  const handleUpload = async () => {
    if (!file) return;

    const formData = new FormData();
    formData.append("tematicaImage", file);

    try {
      setLoading(true);
      const response = await axios.post(
        "https://portaltransaccionalback.azurewebsites.net/api/SubeImagen/" +
          id,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      console.log("Respuesta del servidor:", response.data);

      // Mostrar SweetAlert y redirigir
      Swal.fire({
        icon: "success",
        title: "Cargado con éxito",
        text: "La imagen se subió correctamente.",
        confirmButtonText: "Aceptar",
      }).then(() => {
        console.log(id);
        navigate("/Preguntas/" + id); // Cambia "/otra-pagina" por tu ruta de destino
      });
    } catch (error) {
      console.error("Error al subir la imagen:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Hubo un problema al subir la imagen.",
      });
    } finally {
      setLoading(false);
    }
  };
  const finaliza = async (e) => {
    e.preventDefault();
    window.location.href = "/Preguntas/" + id;
  };
  return (
    <div className="container">
      <div className="text-center">
        <div className="container-fluid">
          <div
            className="card shadow mb-4"
            style={{
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "20px",
              width: "50%",
              height: "auto",
              margin: "0 auto",
            }}
          >
            <div className="card-header py-3">
              <Box sx={{ maxWidth: 400, margin: "0 auto" }}>
                <Typography variant="h6" gutterBottom>
                  Arrastre o suba la imagen de la temática
                </Typography>
                <DropzoneContainer {...getRootProps()}>
                  <input {...getInputProps()} />
                  <Typography variant="body2">
                    Arrastre una imagen aquí o haga clic para subir.
                  </Typography>
                </DropzoneContainer>
                {uploadedImage && (
                  <ImagePreview src={uploadedImage} alt="Imagen subida" />
                )}
                <Box mt={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleUpload}
                    disabled={!file || loading}
                  >
                    {loading ? "Subiendo..." : "Subir Imagen"}
                  </Button>
                </Box>
                <hr />
                <Button variant="contained" color="warning" onClick={finaliza}>
                  Continuar sin Imagen
                </Button>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubeImagen;
